import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar          from "./components/Navbar";
import Footer          from "./components/Footer";
import Home            from "./pages/Home";
import Classes         from "./pages/Classes";
import ClassDetail     from "./pages/ClassDetail";
import Articles        from "./pages/Articles";
import ArticleDetail   from "./pages/ArticleDetail";
import Resources       from "./pages/Resources";
import ResourceDetail  from "./pages/ResourceDetail";
import Login           from "./pages/Login";
import AdminPanel      from "./pages/AdminPanel";
import Profile         from "./pages/Profile";
import SetPassword     from "./pages/SetPassword";
import AdminProfile    from "./pages/AdminProfile";
import ScrollToTop     from "./components/ScrollToTop";

import "./styles/global.css";

const PAGE_TITLES = {
  "/":             "StatistikData | Inicio",
  "/clases":       "Clases",
  "/articulos":    "Artículos",
  "/recursos":     "Recursos",
  "/login":        "Login",
  "/perfil":       "Mi perfil",
  "/admin":        "Panel Admin",
  "/admin/perfil": "Perfil Admin",
  "/set-password": "Cambiar contraseña",
};

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding:"2rem", fontFamily:"sans-serif" }}>Verificando sesión...</div>;
  if (!user || (user.role !== "admin" && user.role !== "collaborator")) return <Navigate to="/login" replace />;
  return children;
}

function AppLayout() {
  const location = useLocation();

  useEffect(() => {
    const base = "/" + location.pathname.split("/")[1];
    document.title =
      PAGE_TITLES[location.pathname] ??
      PAGE_TITLES[base] ??
      "StatistikData | Bioestadística UNMSM";
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/"              element={<Home />} />
        <Route path="/clases"        element={<Classes />} />
        <Route path="/clases/:id"    element={<ClassDetail />} />
        <Route path="/articulos"     element={<Articles />} />
        <Route path="/articulos/:id" element={<ArticleDetail />} />
        <Route path="/recursos"      element={<Resources />} />
        <Route path="/recursos/:id"  element={<ResourceDetail />} />
        <Route path="/login"         element={<Login />} />
        <Route path="/perfil"        element={<Profile />} />
        <Route path="/set-password"  element={<SetPassword />} />
        <Route path="/admin"         element={<AdminRoute><AdminPanel /></AdminRoute>} />
        <Route path="/admin/perfil"  element={<AdminProfile />} />
        <Route path="*"              element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppLayout />
      </AuthProvider>
    </BrowserRouter>
  );
}